import { useState } from "react";
import { useNavigate, Link, Navigate } from "react-router-dom";
import { useAuth, formatApiErrorDetail } from "@/lib/auth";
import { Loader2 } from "lucide-react";

export default function Login() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    try { await login(email, password); nav("/"); }
    catch (ex) { setErr(formatApiErrorDetail(ex.response?.data?.detail) || "Accesso fallito"); }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-[#090D14] flex items-center justify-center p-4">
      <div className="w-full max-w-sm">
        <div className="flex items-center gap-3 mb-8 justify-center">
          <img src="/betti-logo.jpg" alt="Betti SRL" className="w-14 h-14 rounded-xl object-cover bg-white shadow-lg shadow-amber-500/10" />
          <div>
            <h1 className="font-head font-bold text-xl text-slate-100 leading-none">Betti SRL</h1>
            <p className="text-xs text-slate-500 mt-1 font-mono">Socio Virtuale</p>
          </div>
        </div>
        <form onSubmit={submit} className="bg-[#121824] border border-[#222D42] rounded-2xl p-6 shadow-2xl space-y-4">
          <h2 className="font-head text-lg font-semibold text-slate-100">Accedi</h2>
          {err && <div data-testid="login-error" className="bg-red-500/10 border border-red-500/20 text-red-400 text-sm rounded-lg px-3 py-2">{err}</div>}
          <div>
            <label className="text-xs uppercase tracking-wider text-slate-500 font-medium block mb-1.5">Email</label>
            <input data-testid="login-email-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="w-full bg-[#1A2335] border border-[#222D42] rounded-lg px-3 py-2.5 text-sm text-slate-100 focus:outline-none focus:border-amber-500/50" placeholder="tua@email.it" />
          </div>
          <div>
            <label className="text-xs uppercase tracking-wider text-slate-500 font-medium block mb-1.5">Password</label>
            <input data-testid="login-password-input" type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="w-full bg-[#1A2335] border border-[#222D42] rounded-lg px-3 py-2.5 text-sm text-slate-100 focus:outline-none focus:border-amber-500/50" placeholder="••••••••" />
          </div>
          <button data-testid="login-submit-button" type="submit" disabled={loading} className="w-full bg-amber-500 hover:bg-amber-400 text-slate-950 font-semibold py-2.5 rounded-lg transition-colors flex items-center justify-center gap-2 disabled:opacity-60">
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : null} Entra
          </button>
          <div className="text-center">
            <Link to="/forgot-password" className="text-xs text-slate-500 hover:text-amber-400 transition-colors">Password dimenticata?</Link>
          </div>
        </form>
      </div>
    </div>
  );
}
